export default __webpack_public_path__ + "static/media/location.6309ee82.svg";